export function isTruthy<T>(value?: T | false | null | undefined): value is T {
  return Boolean(value);
}
